export default "__VITE_ASSET__Df0VmRvJ__"